<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <!-- <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7"></div>
      </div>
    </base-header> -->
    <div class="add-new-notification">
      <card>
        <!-- Card header -->
        <h2 slot="header" class="mb-0" v-if="this.tempId">
          Edit Notification
        </h2>
        <h2 slot="header" class="mb-0" v-else>
          Add Notification
        </h2>
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form class="needs-validation" @submit.prevent="handleSubmit()" enctype="multipart/form-data">
            <div class="form-row">
              <div class="col-md-12 mb-3">
                <label class="form-control-label">Role</label>
                <br>
                <el-select  style="width: 100%"  class="select-primary select-style" v-model="role" placeholder="Role">
                  <el-option class="select-primary" v-for="item in categories" :key="item.value" :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-12">
              <base-input label="Select Companies">
                <el-select style="width: 100%" filterable multiple placeholder="Select Company"
                class="select-primary select-style"
                 remote
                 reserve-keyword
                 v-model="selectedCompanies"
                 :remote-method="fetchData"
                 >

                  <el-option v-for="(option, index) in companiesOption" :key="'company' + index" :value="option.id"
                    :label="option.name">
                  </el-option>
                </el-select>
              </base-input>

            </div>
              <!-- <div class="col-md-12">
                <base-input label="Notification Title" name="notification_title" placeholder="Notification Title"
                  rules="required" v-model="title">
                </base-input>
              </div> -->
              <div class="col-md-12">
                <base-input class="input-style" label="Notification Message" name="notification_message" placeholder="Notification Message"
                  v-model="message">
                </base-input>
              </div>

            </div>
            <div class="text-right">
              <base-button type="danger" class="greybtn font-weight-normal px-5 mr-1 mr-sm-3"
                @click="$router.go(-1)">Cancel</base-button>
              <base-button type="primary" class="font-weight-normal px-5"
                @click.prevent="saveNotification()">Submit</base-button>
            </div>
          </form>
        </validation-observer>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      hot_user: "",
      hot_token: "",
      config: "",
      tempId: "",
      categories: [
        {
          name: "Company Admin",
          value: "company_admin"
        },
        {
          name: "Manager",
          value: "manager"
        },
        {
          name: "Employee",
          value: "employee"
        },
        {
          name: "Everyone",
          value: "everyone"
        },

      ],
      role: "",
      message: "",
      title: "",
      selectedCompanies: [],
      companiesOption: [],
    };
  },
  created() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }
    if (this.$route.query.id) {
      this.tempId = this.$route.query.id;
      this.$http.get("/notification/" + this.tempId).then(resp => {
        this.role =  resp.data.role;
        this.title = resp.data.title;
        this.message = resp.data.message;
      });
    }
  },

  methods: {
    fetchData(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.$http
            .get('/all-companies', { params: { query } }) // Use 'params' for query parameters
            .then((resp) => {
              this.companiesOption = resp.data; // Update the userOptions with response data
            })
            .catch((error) => {
              console.error('Error fetching users:', error);
            })
            .finally(() => {
              this.loading = false; // Always stop loading indicator
            });
        }, 400);
      } else {
        this.companiesOption = []; // Reset userOptions if query is empty
      }
    },
    saveNotification() {
      if (this.tempId !== "") {
        this.$http
          .put("/notification/update/" + this.tempId, {
            title: this.title,
            message: this.message,
            role: this.role,
          })
          .then((resp) => {
            // Handle success response
            // console.log("Notification created successfully:", resp.data);

            // Show a success message (using Swal or any other library)
            Swal.fire({
              title: "Success!",
              text: "Notification has been created successfully!",
              icon: "success",
              confirmButtonClass: 'btn btn-success',
                                confirmButtonText: 'Ok'
            });

            // Optionally, reset the form fields
            this.title = "";
            this.message = "";
            this.role = "";

            // Optionally, redirect the user
            this.$router.push("/all_notifications");
          })
          .catch((error) => {

            // Show an error message (using Swal or any other library)
            Swal.fire({
              title: "Error!",
              text: error.response?.data?.message || "Failed to create notification.",
              icon: "error",
              confirmButtonClass: 'btn btn-success',
                                confirmButtonText: 'Ok'
            });
          });
      } else {
        this.$http
          .post("notification/save", {
            title: this.title,
            message: this.message,
            role: this.role,
            companies :  this.selectedCompanies
          })
          .then((resp) => {
            // Handle success response
            // console.log("Notification created successfully:", resp.data);

            // Show a success message (using Swal or any other library)
            Swal.fire({
              title: "Success!",
              text: "Notification has been created successfully!",
              icon: "success",
              confirmButtonClass: 'btn btn-success',
                                confirmButtonText: 'Ok'
            });

            // Optionally, reset the form fields
            this.title = "";
            this.message = "";
            this.role = "";

            // Optionally, redirect the user
            this.$router.push("/all_notifications");
          })
          .catch((error) => {

            // Show an error message (using Swal or any other library)
            Swal.fire({
              title: "Error!",
              text: error.response?.data?.message || "Failed to create notification.",
              icon: "error",
              confirmButtonClass: 'btn btn-success',
                                confirmButtonText: 'Ok'
            });
          });
      }
    }
  }
};
</script>
<style>
.stripe-card {
  border: 1px solid grey;
}

.stripe-card.complete {
  border-color: green;
}

.logo-size {
  width: 60%;
  height: auto;
}
</style>
